import { render, staticRenderFns } from "./DataRouter.vue?vue&type=template&id=fb2a0354&"
import script from "./DataRouter.vue?vue&type=script&lang=js&"
export * from "./DataRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports